import { uniqueId } from "lodash";
import { useEffect, useState } from "react";
import Button, {
  ButtonTypes,
} from "../../../../common/components/button/button";
import MultipleChooseOption from "../../../../common/components/inputFields/multipleChooseOption/multipleChooseOption";
import RangeSlider from "../../../../common/components/inputFields/rangeSlider/rangeSlider";
import TextField from "../../../../common/components/inputFields/textFields/textField";
import { TicketDetailModel } from "../../models/ticketDetailModel";
import ImageIcon from "../../../../assets/imageIcon.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/infoIcon.svg";
import "./ticketDetailArea.scss";
import Tooltip from "../../../../common/components/tooltip/tooltip";
import { useLoadHandler } from "../../../../common/customHooks/useLoadHandler";
import { FileApi } from "../../../../common/services/api/fileApi";
import { Color } from "../../../../common/style/colors";

export default function TicketDetailArea(props: {
  initialValue?: TicketDetailModel;
  totalScore?: number;
  onChange?: (e: TicketDetailModel) => void;
}) {
  let totalScore = props.totalScore ?? 0;
  const [ticketDetail, setTicketDetail] = useState<TicketDetailModel>(
    props.initialValue ?? ({} as TicketDetailModel)
  );
  const [currentRow, setCurrentRow] = useState(0);

  useEffect(() => {
    props.onChange?.(ticketDetail);
  }, [ticketDetail]);

  const {
    loadingStatus: logoLoadingStatus,
    callFetchAsync: logoCallFetchAsync,
  } = useLoadHandler(async ([index, file]: [number, File]) => {
    let result = await FileApi.uploadFile(file);
    let temp = { ...ticketDetail };
    if (temp.userResult?.data?.ticketRangeDetail?.[index])
      temp.userResult.data.ticketRangeDetail[index].logoImage = result;
    setTicketDetail(temp);
  });

  const {
    loadingStatus: backgroundLoadingStatus,
    callFetchAsync: backgroundCallFetchAsync,
  } = useLoadHandler(async ([index, file]: [number, File]) => {
    let result = await FileApi.uploadFile(file);
    let temp = { ...ticketDetail };
    if (temp.userResult?.data?.ticketRangeDetail?.[index])
      temp.userResult.data.ticketRangeDetail[index].backgroundImage = result;
    setTicketDetail(temp);
  });

  return (
    <div className="ticket-detail-area">
      <h3 className="ticket-detail-title">Choose ticket detail</h3>
      <hr style={{ width: "100%" }} />
      <div className="ticket-detail-options">
        <MultipleChooseOption
          maxWidth="400px"
          viewOnly
          initialValue={{ option: "Event Name", score: undefined }}
          isSelected={ticketDetail?.eventName?.isShow}
          onClick={() =>
            setTicketDetail({
              ...ticketDetail,
              eventName: {
                ...ticketDetail.eventName,
                isShow: !ticketDetail.eventName?.isShow,
              },
            } as TicketDetailModel)
          }
        >
          <TextField
            placeHolder="Event Name"
            initialValue={ticketDetail.eventName?.data ?? ""}
            onChange={(e) =>
              setTicketDetail({
                ...ticketDetail,
                eventName: {
                  ...ticketDetail.eventName,
                  data: e,
                },
              } as TicketDetailModel)
            }
          />
        </MultipleChooseOption>
        <MultipleChooseOption
          maxWidth="400px"
          viewOnly
          initialValue={{ option: "Full Name", score: undefined }}
          isSelected={ticketDetail?.fullName?.isShow}
          onClick={() =>
            setTicketDetail({
              ...ticketDetail,
              fullName: {
                ...ticketDetail.fullName,
                isShow: !ticketDetail.fullName?.isShow,
              },
            } as TicketDetailModel)
          }
        >
          <TextField
            placeHolder="Question Title"
            initialValue={ticketDetail.fullName?.data ?? ""}
            onChange={(e) =>
              setTicketDetail({
                ...ticketDetail,
                fullName: {
                  ...ticketDetail.fullName,
                  data: e,
                },
              } as TicketDetailModel)
            }
          />
        </MultipleChooseOption>
        <MultipleChooseOption
          maxWidth="400px"
          viewOnly
          initialValue={{ option: "Id", score: undefined }}
          isSelected={ticketDetail?.id?.isShow}
          onClick={() =>
            setTicketDetail({
              ...ticketDetail,
              id: {
                ...ticketDetail.id,
                isShow: !ticketDetail.id?.isShow,
              },
            } as TicketDetailModel)
          }
        />
        <MultipleChooseOption
          maxWidth="400px"
          viewOnly
          initialValue={{ option: "Date", score: undefined }}
          isSelected={ticketDetail?.date?.isShow}
          onClick={() =>
            setTicketDetail({
              ...ticketDetail,
              date: {
                ...ticketDetail.date,
                isShow: !ticketDetail.date?.isShow,
              },
            } as TicketDetailModel)
          }
        />
        <MultipleChooseOption
          maxWidth="400px"
          viewOnly
          initialValue={{ option: "User Result", score: undefined }}
          isSelected={ticketDetail?.userResult?.isShow}
          onClick={() =>
            setTicketDetail({
              ...ticketDetail,
              userResult: {
                isShow: !ticketDetail.userResult?.isShow,
                data: {
                  rangeValues: undefined,
                  ticketRangeDetail: [{} as TicketDetailModel],
                },
              },
            } as TicketDetailModel)
          }
        >
          <RangeSlider
            score={totalScore}
            values={ticketDetail.userResult?.data?.rangeValues ?? []}
            onChange={(e) => {
              let temp = { ...ticketDetail };
              let oldLength = temp.userResult!.data?.rangeValues?.length;
              if (temp.userResult?.data) {
                if ((e?.length ?? 0) > (oldLength ?? 0)) {
                  temp.userResult.data.rangeValues = e;
                  temp.userResult.data.ticketRangeDetail?.push({});
                } else if ((e?.length ?? 0) < (oldLength ?? 0)) {
                  temp.userResult.data.rangeValues = e;
                  temp.userResult.data.ticketRangeDetail?.splice(-1);
                } else {
                  temp.userResult.data.rangeValues = e;
                }
                setTicketDetail(temp);
              }
            }}
          />
          {[...(ticketDetail.userResult?.data?.rangeValues ?? []), 0].map(
            (e, i) => {
              let logoId = uniqueId();
              let bgId = uniqueId();
              return (
                <div className="user-result-detail-container" key={i}>
                  <p>{`Data show for score <= ${
                    ticketDetail.userResult?.data?.rangeValues?.length == i ||
                    !ticketDetail.userResult?.data?.rangeValues?.length
                      ? totalScore
                      : e
                  }`}</p>
                  <div className="user-result-detail">
                    <TextField
                      placeHolder="Description"
                      isFullWidth
                      initialValue={
                        ticketDetail.userResult?.data?.ticketRangeDetail?.[i]
                          ?.description ?? ""
                      }
                      onChange={(e) => {
                        let temp = { ...ticketDetail };
                        temp.userResult!.data!.ticketRangeDetail![
                          i
                        ].description = e;
                        setTicketDetail(temp);
                      }}
                    />
                    <div className="upload-images-container">
                      Upload Images
                      <Tooltip
                        text={
                          "Accept all types of image file, optimal size for background is 300KB (700*220) and optimal size for logo is 200KB (200*200)"
                        }
                      >
                        <InfoIcon width={15} height={15} />
                      </Tooltip>
                    </div>
                    <div className="user-result-button-container">
                      <div className="user-result-button">
                        <input
                          type="file"
                          accept="image/*"
                          id={logoId}
                          style={{ display: "none" }}
                          onChange={(e) =>
                            logoCallFetchAsync([i, e.target.files?.[0]])
                          }
                        />
                        <img
                          className="user-result-image"
                          src={
                            ticketDetail.userResult?.data?.ticketRangeDetail?.[
                              i
                            ]?.logoImage ?? ImageIcon
                          }
                        />
                        <Button
                          type={ButtonTypes.OUTLINED}
                          loadingStatus={
                            currentRow == i ? logoLoadingStatus : undefined
                          }
                          loadSpinColor={Color().primaryColor}
                          text={"Upload Logo"}
                          isFullWidth
                          onClick={() => {
                            setCurrentRow(i);
                            document.getElementById(logoId)?.click();
                          }}
                        />
                      </div>
                      <div className="user-result-button">
                        <input
                          type="file"
                          accept="image/*"
                          id={bgId}
                          style={{ display: "none" }}
                          onChange={(e) =>
                            backgroundCallFetchAsync([i, e.target.files?.[0]])
                          }
                        />
                        <img
                          className="user-result-image"
                          src={
                            ticketDetail.userResult?.data?.ticketRangeDetail?.[
                              i
                            ]?.backgroundImage ?? ImageIcon
                          }
                        />
                        <Button
                          type={ButtonTypes.OUTLINED}
                          loadingStatus={
                            currentRow == i
                              ? backgroundLoadingStatus
                              : undefined
                          }
                          loadSpinColor={Color().primaryColor}
                          text={"Upload BG"}
                          isFullWidth
                          onClick={() => {
                            setCurrentRow(i);
                            document.getElementById(bgId)?.click();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          )}
        </MultipleChooseOption>
      </div>
    </div>
  );
}
